module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft-3-f536be6653c40486cb437bbda56d4b8e.png";